import React from 'react';
import PropTypes from 'prop-types';
import { Image as AtomicImage } from '@thd-olt-component-react/image';
import './Image.scss';

/**
 * @group Layout
 * Displays Etch Image component
 */

const Image = (props) => {
  const { opts = {}, channel } = props;
  const {
    id,
    link,
    mediaData = {},
    mediaMobileData = {},
    isStretchy,
    name
  } = opts;
  const imageSrc = channel === 'mobile' && mediaMobileData.src ? mediaMobileData.src : mediaData.src;
  const imagealt = channel === 'mobile' && mediaMobileData.alt ? mediaMobileData.alt : mediaData.alt;
  return (
    <div className="content_image" id={id}>
      {link
        && (
          <a href={link}>
            <AtomicImage
              stretchy
              src={imageSrc}
              className={isStretchy ? 'stretchy' : ''}
              alt={imagealt}
              title={name}
              lazy
            />
          </a>
        )}
      {!link
        && <AtomicImage
          stretchy
          src={imageSrc}
          className={isStretchy ? 'stretchy' : ''}
          alt={imagealt}
          title={name}
          lazy
        />
      }
    </div>
  );
};

Image.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isStretchy: PropTypes.bool,
    mediaData: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    name: PropTypes.string
  }).isRequired,
  channel: PropTypes.oneOf([
    'desktop',
    'mobile'
  ]),
};

Image.defaultProps = {
  channel: 'desktop'
};

export default Image;
